import { render, staticRenderFns } from "./compClub.vue?vue&type=template&id=024bb9a6&"
import script from "./compClub.vue?vue&type=script&lang=js&"
export * from "./compClub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports